import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import {
  Section,
  Controls,
  InlineControl,
  LabeledControl,
  TextFormat,
  ToggleGroup,
  ToggleOption,
  Checkbox,
  Selection,
  Slider,
  SubHeader,
  Header,
  BackgroundColorControl,
} from '../../../reporting/sidebar/components';
import ChartTitle from '../ChartTitle';

/**
 * @typedef MainConfigProps
 * @prop {*=} meta - chart meta data, see custom_chart_serializer.rb for model
 */
/**
 * @type {React.FC<MainConfigProps>}
 */
function MainConfig({ meta }) {
  const { get, merge } = useReportConfiguration();

  function flipAxes(orientation) {
    merge({
      orientation,
      verticalAxis: get('horizontalAxis'),
      horizontalAxis: get('verticalAxis'),
    });
  }

  return (
    <Section defaultOpen>
      <Header>Chart</Header>
      <ChartTitle />
      <SubHeader>Style</SubHeader>
      <Controls>
        <LabeledControl title='Position' alignTop>
          <ToggleGroup configurationKey='orientation' onChange={flipAxes}>
            <ToggleOption value='vertical'>
              <i className='fa-solid fa-signal-alt-4 fa-flip-horizontal' />
              Vertical
            </ToggleOption>
            <ToggleOption value='horizontal'>
              <i className='fa-solid fa-signal-alt-4 fa-rotate-90' />
              Horizontal
            </ToggleOption>
          </ToggleGroup>
        </LabeledControl>

        <LabeledControl title='Bars' alignTop>
          <Selection
            configurationKey='groupMode'
            options={[
              ['Stacked', 'stacked'],
              ['Grouped', 'grouped'],
            ]}
          />
          <Checkbox
            disabled={get('groupMode') === 'grouped'}
            configurationKey='percentStack'
          >
            100%
          </Checkbox>
          <Checkbox configurationKey={`reverse_${get('chartType')}`}>
            Reverse data
          </Checkbox>
        </LabeledControl>

        <BackgroundColorControl />

        <LabeledControl title='Bar size' alignTop>
          <Slider
            configurationKey='barSize'
            props={{ min: 5, max: 100, step: 1, labeled: 'below' }}
            disabled={false}
          />
        </LabeledControl>

        <LabeledControl title='Data counts'>
          <Selection
            configurationKey='showLabels'
            options={[
              ['On', true],
              ['Off', false],
            ]}
          />
        </LabeledControl>
        <LabeledControl title='Data labels' />
        <InlineControl>
          <TextFormat
            configurationKey='dataLabelFormat'
            defaultSize={12}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
          />
        </InlineControl>
      </Controls>
    </Section>
  );
}

export default MainConfig;
